module.exports = __webpack_public_path__ + "img/icon-wifi-2.d11e372e.svg";